import { getQueryParams } from '@/mm/utils.js'
import { washData } from '@/components/common/controlBar/utils.js'
import {
  extraNode,
  parseThreeEndStyle
} from '@/components/common/controlBar/controlBarDialog/metaComponent/utils.js'
import { getCurrentModule, getCurrentPage, getCurrentPageId, getCurrentPageType } from '@/utils.js'


const _ = {
  state: {
    value: (() => {
      const id = getQueryParams({ key: 'id' })
      const page_type = getQueryParams({ key: 'page_type' })
      if (id) return `${id}_${page_type || 1}`
      return ''
    })(),
    list: [],
    data: null,
    currentPageSelectKey: Date.now()
  },
  mutations: {
    SET_PAGE_VALUE: (state, data) => {
      state.value = data
    },
    SET_PAGE_LIST: (state, data) => {
      state.list = data
    },
    SET_PAGE_DATA: (state, data) => {
      state.data = data
    },
    SET_CURRENT_PAGE_SELECT_KEY: (state, data) => {
      state.currentPageSelectKey = data
    }
  },
  actions: {
    GetPageList({ commit, state }, params) {
      return mm
        .http({
          url: '/api/page/list',
          method: 'get',
          params
        })
        .then(({ data }) => {
          commit(
            'SET_PAGE_LIST',
            data.list.map((item) => {
              if (['产品分类页', '产品列表页', '产品详情页'].find((item2) => item2 === item.name))
                item.isShowLayout = true
              return item
            })
          )
          if (!state.value) {
            commit('SET_PAGE_VALUE', `${state.list[0].id}_${state.list[0].page_type}`)

            commit('SET_CURRENT_PAGE_SELECT_KEY', Date.now())

            // location.href = createUrl({
            //   id: state.list[0].id,
            //   page_type: state.list[0].page_type
            // })
          }
          return data
        })
    },
    CreatePage(_, data) {
      return mm
        .http({
          url: '/ksh/blankPage/createPost',
          method: 'post',
          data
        })
        .then(({ data }) => {
          return data
        })
    },
    async GetPageDetail({ commit, state }, params) {
      var info = {}

      if (params.globalBackGroundtype) {
        info = params
      } else {
        info = getCurrentPage()
      }
      commit('SET_PAGE_DATA', info)

      function transformDataConstrucotr() {
        // 默认布局
        const resList = [
          ({
            name: '头部',
            startNode: true,
            componentName: 'head',
            _type: 'headBase',
            list: [
              {
                name: '空白模块',
                tips: '可拖入控件到此位置',
                componentName: 'module',
                _type: 'module1',
                startNode: true,
                id: 'id_0_0',
                list: [
                  {
                    name: '一行一列',
                    _type: 'widgets_rowCol1',
                    componentName: 'rowCol2',

                    id: 'id_0_0_0',
                    diffWidth: ['p1-0', 's1-0'],
                    changeWidth:false,
                    list: [
                      {
                        name: '列',
                        componentName: 'col',
                        _width: '100'
                      }
                    ]
                  }
                ]
              }
            ]
          }),
          ({
            name: '页面',
            startNode: true,
            componentName: 'content',
            _type: 'bodyBase',
            list: [
              {
                name: '空白模块',
                tips: '可拖入控件到此位置',
                componentName: 'module',
                _type: 'module1',
                startNode: true,
                id: 'id_1_0',
                list: [
                  {
                    name: '一行一列',
                    _type: 'widgets_rowCol1',
                    componentName: 'rowCol2',

                    changeWidth:false,
                    id: 'id_1_0_0',
                    diffWidth: ['p1-0', 's1-0'],
                    list: [
                      {
                        name: '列',
                        componentName: 'col',
                        _width: '100'
                      }
                    ]
                  }
                ]
              }
            ]
          }),
          ({
            name: '底部',
            startNode: true,
            componentName: 'foot',
            _type: 'footBase',
            list: [
              {
                name: '空白模块',
                tips: '可拖入控件到此位置',
                componentName: 'module',
                startNode: true,
                _type: 'module1',
                id: 'id_2_0',
                list: [
                  {
                    name: '一行一列',
                    _type: 'widgets_rowCol1',
                    componentName: 'rowCol2',

                    changeWidth:false,
                    id: 'id_2_0_0',
                    diffWidth: ['p1-0', 's1-0'],
                    list: [
                      {
                        name: '列',
                        componentName: 'col',
                        _width: '100'
                      }
                    ]
                  }
                ]
              }
            ]
          })
        ]

        info.header_content._type = 'headBase'
        info.content._type = 'bodyBase'
        info.footer_content._type = 'footBase'

        const content = { list: [] }
        if (info.header_content?.list?.length) {
          content.list.push({
            startNode: true,
            ...info.header_content,
            name: '头部',
            componentName: 'head'
          })
        } else {
          content.list.push(resList[0])
        }
        if (info.content?.list?.length) {
          content.list.push({
            startNode: true,
            ...info.content,
            name: '页面',
            componentName: 'content'
          })
        } else {
          content.list.push(resList[1])
        }
        if (info.footer_content?.list?.length) {
          content.list.push({
            ...info.footer_content,
            startNode: true,
            name: '底部',
            componentName: 'foot'
          })
        } else {
          content.list.push(resList[2])
        }

        return [content, resList]
      }

      var [content, resList] = transformDataConstrucotr()

      // 处理传入的 layout
      const updateLayout = (list) => {
        const layout = mm.utils.getQueryParams({ key: 'layout' })
        if (layout === '0') {
          list[1].list = [
            {
              name: '空白模块',
              componentName: 'module',
              _type: 'module1',
              startNode: true,
              data: {
                design: {
                  self_marginTop: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_marginBottom: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_marginUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  }
                }
              },
              list: [
                {
                  name: '一行一列',
                  componentName: 'rowCol2',
                  _type: 'widgets_rowCol1',
                  list: [
                    {
                      name: '列',
                      componentName: 'col',
                      _width: '100'
                    }
                  ],
                  data: {
                    design: {
                      self_marginTop: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginBottom: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      }
                    },
                    isShow: true
                  }
                },
                {
                  name: '一行两列',
                  componentName: 'rowCol2',
                  _type: 'widgets_rowCol1',
                  diffWidth: ['p2-1', 's2-1'],
                  list: [
                    {
                      name: '列',
                      componentName: 'col',
                      _width: '20'
                    },
                    {
                      name: '列',
                      componentName: 'col',
                      _width: '80'
                    }
                  ],
                  data: {
                    design: {
                      self_marginTop: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginBottom: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      }
                    },
                    isShow: true
                  }
                }
              ]
            }
          ]
        } else if (layout === '1') {
          list[1].list = [
            {
              name: '空白模块',
              componentName: 'module',
              _type: 'module1',
              startNode: true,
              data: {
                design: {
                  self_marginTop: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_marginBottom: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_marginUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  }
                }
              },
              list: [
                {
                  name: '一行一列',
                  componentName: 'rowCol2',
                  _type: 'widgets_rowCol1',
                  list: [
                    {
                      name: '列',
                      componentName: 'col',
                      _width: '100'
                    }
                  ],
                  data: {
                    design: {
                      self_marginTop: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginBottom: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      }
                    },
                    isShow: true
                  }
                },
                {
                  name: '一行两列',
                  componentName: 'rowCol2',
                  _type: 'widgets_rowCol1',
                  diffWidth: ['p2-1', 's2-1'],
                  list: [
                    {
                      name: '列',
                      componentName: 'col',
                      _width: '20'
                    },
                    {
                      name: '列',
                      componentName: 'col',
                      _width: '80'
                    }
                  ],
                  data: {
                    design: {
                      self_marginTop: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginBottom: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      }
                    },
                    isShow: true
                  }
                },
                {
                  name: '一行一列',
                  componentName: 'rowCol2',
                  _type: 'widgets_rowCol1',
                  list: [
                    {
                      name: '列',
                      componentName: 'col',
                      _width: '100'
                    }
                  ],
                  data: {
                    design: {
                      self_marginTop: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginBottom: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      }
                    },
                    isShow: true
                  }
                }
              ]
            }
          ]
        } else if (layout === '2') {
          list[1].list = [
            {
              name: '空白模块',
              componentName: 'module',
              _type: 'module1',
              startNode: true,
              data: {
                design: {
                  self_marginTop: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_marginBottom: {
                    diannao: 0,
                    pingban: 0,
                    shouji: 0
                  },
                  self_marginUnit: {
                    diannao: 'px',
                    pingban: 'px',
                    shouji: 'px'
                  }
                }
              },
              list: [
                {
                  name: '一行一列',
                  componentName: 'rowCol2',
                  _type: 'widgets_rowCol1',
                  list: [
                    {
                      name: '列',
                      componentName: 'col',
                      _width: '100'
                    }
                  ],
                  data: {
                    design: {
                      self_marginTop: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginBottom: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      }
                    },
                    isShow: true
                  }
                },
                {
                  name: '一行一列',
                  componentName: 'rowCol2',
                  _type: 'widgets_rowCol1',
                  list: [
                    {
                      name: '列',
                      componentName: 'col',
                      _width: '100'
                    }
                  ],
                  data: {
                    design: {
                      self_marginTop: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginBottom: {
                        diannao: 0,
                        pingban: 0,
                        shouji: 0
                      },
                      self_marginUnit: {
                        diannao: 'px',
                        pingban: 'px',
                        shouji: 'px'
                      }
                    },
                    isShow: true
                  }
                }
              ]
            }
          ]
        }
      }
      updateLayout(content.list)


      addIds(content.list)
      function addIds(list, id) {
        for (let i = 0; i < list.length; i++) {
          list[i].id = id ? `${id}_${i}` : `id_${i}`
          if (list[i].list) {
            addIds(list[i].list, list[i].id)
          }
        }
      }


      self.hasList = content.list

      washData({ content })
      var newList = (() => {
        if (content.list.length) {
          return content.list
        } else {
          return resList
        }
      })()




      var newList = (() => {
        if (content.list.length) {
          newList = newList.map((baseNode) => {
            return extraNode(baseNode, true)
          })
          return newList
        } else {
          return newList.map((item)=>{
            return extraNode(item)
          })
        }
      })()



      mm.utils.formatListName(newList)







      if (!params.globalBackGroundtype) {
        commit('UPDATE_HAS_LIST', newList)
      }

      setTimeout(() => {
        mm.oldHasList = JSON.parse(JSON.stringify(mm.store.state.hasList))
        mm.history()
      }, 6000)

      return newList
    },
    // GetDetail({ commit, state }, params) {
    //   const { id } = state
    //   if (id) {
    //     return mm
    //       .http({
    //         url: '/api/page/info',
    //         method: 'get',
    //         params: {
    //           page_id:id,
    //           ...params
    //         }
    //       })
    //       .then(({ data }) => {
    //         data = washData(data)
    //         return data
    //       })
    //   }
    // },
    GetEditPage({ state }, params) {
      return mm
        .http({
          url: '/ksh/blankPage/edit',
          method: 'get',
          params: {
            ...params
          }
        })
        .then((res) => {
          return res.data.info
        })
    },
    CopyPage({ state }, data) {
      return mm
        .http({
          url: '/ksh/blankPage/copyPost',
          method: 'post',
          data
        })
        .then((res) => {
          return res.data.info
        })
    },
    EditPage({ state }, data) {
      return mm
        .http({
          url: '/ksh/blankPage/editPost',
          method: 'post',
          data: {
            ...data
          }
        })
        .then((res) => {
          return res
        })
    },
    DeletePage(_, data) {
      return mm
        .http({
          url: '/ksh/blankPage/delete',
          method: 'post',
          data
        })
        .then(({ data }) => {
          return data
        })
    },
    //重新关联模版
    RelatedTemplate(_, data) {
      return mm
        .http({
          url: '/ksh/template/relatedTemplate',
          method: 'post',
          data
        })
        .then(({ data }) => {
          return data
        })
    },
    Preview({ state }, data) {
      if (mm.store.state.authInfo.type === 'module') {
        return mm
          .http({
            url: '/api/module/preview',
            method: 'get',
            params: {
              id: getCurrentModule().id
            }
          })
          .then(({ data }) => {
            return data
          })
      } else if (mm.store.state.authInfo.type === 'template') {
        return mm
          .http({
            url: '/api/template/preview',
            method: 'get',
            params: {
              page_id: getCurrentPage().page_id,
              a_ksh_template_id: getCurrentPage().a_ksh_template_id,
              page_type: getCurrentPageType(getCurrentPageId(), mm.store.state.page.list)
            }
          })
          .then(({ data }) => {
            return data
          })
      } else {
        return mm
          .http({
            url: '/api/sites/preview',
            method: 'get',
            params: {
              id: getCurrentPageId(),
              a_langset_id: parseInt(mm.store.state.currentLanguage),
              page_type: getCurrentPageType(getCurrentPageId(), mm.store.state.page.list),
              ...data
            }
          })
          .then(({ data }) => {
            return data
          })
      }
    }
  }
}

export default _
